import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { useSwiper } from 'swiper/react';
import SwiperButton from './SwiperButton';
const QuestionHeader = ({ title, questionNumber, choices }) => {
    const [count, setCount] = useState(1);
    const [isBeginning, setIsBeginning] = useState(true);
    const [isEnd, setIsEnd] = useState(false);
    const swiper = useSwiper();
    useEffect(() => {
        if (count !== 1) {
            setIsBeginning(false);
        }
        else {
            setIsBeginning(true);
        }
        if (count !== choices) {
            setIsEnd(false);
        }
        else {
            setIsEnd(true);
        }
    }, [count]);
    const handleNext = () => {
        if (count !== choices) {
            swiper.slideNext();
            setCount((prevState => prevState + 1));
        }
    };
    const handlePrevious = () => {
        if (count !== 1) {
            swiper.slidePrev();
            setCount((prevState => prevState - 1));
        }
    };
    return (_jsxs("header", { className: "flex items-end justify-between", children: [title && _jsxs("h3", { className: "text-black", children: [_jsxs("span", { className: "text-gold", children: [questionNumber, "."] }), " ", title] }), _jsxs("div", { className: "hidden tablet-portrait:flex tablet-portrait:items-center tablet-portrait:flex-none tablet-portrait:space-x-2", children: [_jsx(SwiperButton, { onClick: () => handlePrevious(), name: "prev", isDisabled: isBeginning }), _jsx(SwiperButton, { onClick: () => handleNext(), name: "next", icon: "arrow-right", isDisabled: isEnd })] })] }));
};
export default QuestionHeader;
